/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable class-methods-use-this */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';

import { Typography, ThemeProvider, Select, FormControl, InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import Text from '@lc/ui/components/Text';
import Button from '@lc/ui/components/Button';

import routes from '@lc/lib/routes';

import datePickerTheme from 'components/SearchBox/DatePickerMUITheme';

class LocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date) {
    return moment(date).format('MMMM [de] YYYY');
  }

  getWeekdays() {
    const getDayInitials = day =>
      moment()
        .isoWeekday(day)
        .format('ddd');
    return [getDayInitials(7), `2 ͣ`, `3 ͣ`, `4 ͣ`, `5 ͣ`, `6 ͣ`, getDayInitials(6)];
  }
}
const StylizedDatePicker = props => (
  <MuiPickersUtilsProvider utils={LocalizedUtils}>
    <ThemeProvider theme={datePickerTheme}>
      <DatePicker {...props} />
    </ThemeProvider>
  </MuiPickersUtilsProvider>
);

function getTimes(date) {
  const items = [];
  new Array(12).fill().forEach((_, index) => {
    const hour1 = moment(date).set({ hour: index + 9, minute: 0 });
    const hour30 = moment(date).set({ hour: index + 9, minute: 30 });

    const hasPassed1 = moment(hour1).isBefore(moment());
    const hasPassed30 = moment(hour30).isBefore(moment());

    items.push({
      time: hour1.format('HH:mm'),
      disabled: hasPassed1,
    });
    items.push({
      time: hour30.format('HH:mm'),
      disabled: hasPassed30,
    });
  });
  return items;
}

const ScheduleModal = ({ classes, roomId, isOpen, hosterName }) => {
  const [dates, setDates] = useState([]);

  const handleChange = (index, value) => {
    const d = [...dates];
    d[index] = { ...d[index], ...value };
    setDates(d);
  };

  const schedule = e => {
    e.preventDefault();
    const filtered = dates.filter(scdt => scdt.date);
    if (filtered.length === 0) return;

    const parsedDate = filtered.reduce((acc, curr, index) => {
      let str = acc;
      str += moment(curr.date).format('DD/MM/YY');
      if (curr.time)
        str += ` às ${curr.time} ${filtered.length > 1 && index === 0 ? 'ou para ' : ''}`;
      return str;
    }, '');

    const msg = `Olá ${hosterName}, gostaria de agendar uma visita no seu consultório para o dia ${parsedDate}. Você possui disponibilidade?`;
    sessionStorage.setItem('chatSchedule', JSON.stringify(msg));
    Router.push(`${routes.internal.openChat('booker', roomId)}`);
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        // i really hate this MUI
        // get first calendar to show it opened
        document.querySelector('#calendarSchedule0')?.click();
      }, 100);
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <form onSubmit={schedule}>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <div>
            <Text styleAs="h5" color="green">
              <b>Agende sua visita</b>
            </Text>
          </div>
          <div>
            <Typography variant="body1" color="textPrimary">
              Escolha duas opções de datas e horários
            </Typography>
          </div>
        </div>

        {[0, 1].map(dindex => (
          <div key={dindex} className={classes.dates}>
            <StylizedDatePicker
              id={`calendarSchedule${dindex}`}
              autoOk
              disablePast
              disableToolbar
              variant="inline"
              minDate={moment()}
              labelFunc={() =>
                dates[dindex]?.date ? moment(dates[dindex]?.date).format('DD/MM/YYYY') : ''
              }
              value={dates[dindex]?.date}
              label={`${dindex + 1}ª data`}
              color="secondary"
              format="dd/MM/yyyy"
              onChange={value => {
                handleChange(dindex, { date: value });
              }}
            />
            <FormControl style={{ width: '200px' }}>
              <InputLabel color="secondary">Horário</InputLabel>
              <Select
                disabled={Boolean(dates[dindex]?.date) === false}
                native
                color="secondary"
                onChange={({ target: { value } }) => {
                  handleChange(dindex, { time: value });
                }}
              >
                <option value="" />
                {getTimes(dates[dindex]?.date).map(i => (
                  <option key={i.time} disabled={i.disabled}>
                    {i.time}
                  </option>
                ))}
              </Select>
            </FormControl>
          </div>
        ))}
        <div>
          <Button label="Enviar solicitação" color="secondary" onClick={schedule} />
        </div>
      </div>
    </form>
  );
};

ScheduleModal.propTypes = {
  classes: PropTypes.object.isRequired,
  roomId: PropTypes.string.isRequired,
  hosterName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

const styles = () => ({
  wrapper: {
    padding: '0 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dates: {
    display: 'flex',
    gap: '10px',
  },
});

export default withStyles(styles)(ScheduleModal);
